import React from 'react';
import Icon, { IconProps } from '../Icon';

const ThreeDots: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 15 3"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
        <circle cx="7.5" cy="1.5" r="1.5" fill="currentColor" />
        <circle cx="13.5" cy="1.5" r="1.5" fill="currentColor" />
      </svg>
    </Icon>
  );
};
export default ThreeDots;
